/* import __COLOCATED_TEMPLATE__ from './ajax-text-indicator.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();